module.exports = __webpack_public_path__ + "img/global_loader.c1f3e086.svg";